export enum ChatBotTypes {
  HOMEPAGE = 'homepage',
  LESSON = 'LESSON',
  LC_FEEDBACK = 'lc_feedback',
  HYBRID_CLASS = 'hybrid_class',
  HYBRID_ACTIVITY = 'hybrid_activity',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/chat-bot-types.enum.ts